import { render, staticRenderFns } from "./PolicyDetail.vue?vue&type=template&id=28905fee&"
import script from "./PolicyDetail.vue?vue&type=script&lang=js&"
export * from "./PolicyDetail.vue?vue&type=script&lang=js&"
import style0 from "./PolicyDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports